import { RefObject, useEffect } from 'react';

export function usePersistentFocus<T extends HTMLElement>(
  ref: RefObject<T>,
  enabled = true,
  focusKey?: string,
) {
  useEffect(() => {
    if (!enabled) {
      return undefined;
    }

    const timer = window.setTimeout(() => {
      ref.current?.focus();
    }, 60);

    return () => window.clearTimeout(timer);
  }, [enabled, focusKey, ref]);
}
